module.exports = (parcelRequire.load("8T05X")).then(() => parcelRequire('1vD2l'));